import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */

const SvgQuestion = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    ref={svgRef}
    {...props}
  >
    <path
      fill="#04C"
      fillRule="evenodd"
      d="M8 16c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zM6.007 3.63c-.18.125-.35.26-.507.405l.478.797a.4.4 0 00.609.147c.083-.056.183-.117.301-.185.118-.068.259-.13.422-.185a1.89 1.89 0 01.606-.084c.327 0 .59.09.79.273.198.181.297.426.297.734 0 .252-.051.47-.154.654a2.11 2.11 0 01-.38.496c-.15.147-.312.285-.484.413l-.247.196-.221.203c-.14.137-.251.289-.334.454a.982.982 0 00-.079.584l.076.688a.5.5 0 00.497.445h.364a.5.5 0 00.494-.419l.095-.58a.774.774 0 01.206-.396c.111-.119.243-.239.396-.36l.485-.392a2.632 2.632 0 00.822-1.172c.093-.258.14-.565.14-.919 0-.368-.062-.702-.186-1a2.185 2.185 0 00-.527-.766 2.337 2.337 0 00-.819-.49A3.146 3.146 0 008.08 3a3.597 3.597 0 00-1.483.3 3.505 3.505 0 00-.59.33zm.8 7.82a1.174 1.174 0 00-.083.438c0 .159.028.305.082.44a1.1 1.1 0 00.226.354 1.033 1.033 0 00.76.318 1.056 1.056 0 00.76-.318 1.1 1.1 0 00.225-.353c.055-.136.082-.283.082-.441 0-.154-.027-.3-.082-.437a1.067 1.067 0 00-.985-.682 1.02 1.02 0 00-.423.087 1.077 1.077 0 00-.563.595z"
      clipRule="evenodd"
    />
  </svg>
));
SvgQuestion.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgQuestion;
